import styled from 'styled-components';
import colors from '../../utils/colors';
import mediaQueries from '../../utils/mediaQueries';
import { heights } from '../../utils/theme';
import typography from '../../utils/typography';
import Brand from '../Brand';
import Dropdown from '../Dropdown';
import { StyledText } from '../Text/Text.styles';
const { midnight, white, skyDarker } = colors;
const { display6 } = typography;
export const StyledHeader = styled.header({
    position: 'sticky',
    top: 0,
    flexShrink: 0,
    backgroundColor: midnight,
    height: heights.header,
    padding: '0rem 1.5rem',
    [mediaQueries.to('md')]: {
        padding: '0rem 1rem',
    },
});
export const StyledHeaderNavigation = styled.nav({
    height: '100%',
    width: '100%',
    display: 'flex',
});
export const StyledBrand = styled(Brand)({
    button: {
        [mediaQueries.from('md')]: {
            display: 'none',
        },
    },
});
export const StyledDropdownContainer = styled.div({
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    button: {
        ...display6,
        width: '24px',
        height: '24px',
        padding: 0,
        border: '2px solid transparent',
        borderRadius: '5px',
        backgroundColor: 'inherit',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        '&[data-open="true"], &:hover, &:active, &:focus-visible': {
            border: `2px solid ${skyDarker}`,
            backgroundColor: skyDarker,
        },
        svg: {
            width: heights.menuIcon,
            height: heights.menuIcon,
            color: white,
        },
    },
});
export const StyledUserAndLanguage = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
});
export const StyledLanguage = styled(StyledText).attrs({ size: 'md', color: white })({
    alignSelf: 'end',
});
export const StyledCurrentUser = styled.p({
    display: 'grid',
    textAlign: 'right',
    color: white,
    margin: 0,
    [mediaQueries.to('lg')]: {
        display: 'none',
    },
});
export const DropdownHeader = styled(Dropdown.Header)({
    [mediaQueries.from('lg')]: {
        display: 'none',
    },
});
export const StyledDivider = styled.div.withConfig({
    shouldForwardProp: (prop) => !['hidden'].includes(prop),
})(({ hidden }) => ({
    height: '24px',
    color: white,
    borderRight: '2px solid white',
    margin: '0 2rem',
    [mediaQueries.to('lg')]: {
        margin: '0 1rem',
        ...(hidden && {
            display: 'none',
        }),
    },
}));
